import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-536442e8")

_pushScopeId("data-v-536442e8")
const _hoisted_1 = { class: "uk-modal-dialog uk-modal-body uk-margin-auto-vertical" }
const _hoisted_2 = { class: "modal__title heading-3" }
const _hoisted_3 = { class: "uk-flex uk-flex-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThothButton = _resolveComponent("ThothButton")

  return (_openBlock(), _createBlock("div", {
    id: _ctx.modalId,
    "uk-modal": 
      _ctx.preventBackgroundClick ? 'bg-close: false; esc-close: false' : ''
    
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.image)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            src: _ctx.image,
            alt: "modal__image"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.modalTitle), 1),
      _createVNode("div", {
        class: "modal__text body-2",
        innerHTML: _ctx.modalContent
      }, null, 8, ["innerHTML"]),
      _createVNode("div", _hoisted_3, [
        (_ctx.secondaryButtonAction && _ctx.secondaryButtonText)
          ? (_openBlock(), _createBlock(_component_ThothButton, {
              key: 0,
              text: _ctx.secondaryButtonText,
              size: _ctx.ButtonSize.L,
              emphasis: _ctx.ButtonEmphasis.Text,
              colour: _ctx.ButtonColour.Grey,
              onClick: _ctx.secondaryButtonAction
            }, null, 8, ["text", "size", "emphasis", "colour", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ThothButton, {
          text: _ctx.primaryButtonText,
          size: _ctx.ButtonSize.L,
          emphasis: _ctx.ButtonEmphasis.Contained,
          colour: _ctx.primaryButtonColour,
          onClick: _ctx.primaryButtonAction
        }, null, 8, ["text", "size", "emphasis", "colour", "onClick"])
      ])
    ])
  ], 8, ["id", "uk-modal"]))
})